import { platform } from "./firebase";

// Adaptador de nombres de colecciones y campos entre plataformas.
// Cuando JammerDefense migre sus nombres al esquema canónico,
// basta con igualar los valores de "jd" a los de "cd" y luego
// eliminar este archivo.

export const SCHEMA = {
  cd: {
    groupedAlarms: "GroupedAlarms",
    zoneField: "zoneID",
    platformName: "CarDefense",
    numericIds: true,
    devicesCollection: "Equipos",
  },
  jd: {
    groupedAlarms: "groupedprediccionesareas",
    zoneField: "areaid",
    platformName: "JammerDefense",
    numericIds: false,
    devicesCollection: "equipos",
  },
};

export const schema = SCHEMA[platform];
